/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import "./icon-DGn-d_zv.js";
import { activeIcon as i } from "./elements/icon/active-icon.js";
import { LitElement as a, html as o, nothing as s } from "lit";
import { customElement as c, property as l, state as u } from "lit/decorators.js";
import { ifDefined as d } from "lit/directives/if-defined.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/menu/menu.css.js
var f = r(":host{gap:var(--_menu-group-gap);--_menu-item-gap:var(--menu-item-gap,.25em);--_menu-group-gap:var(--menu-group-gap,.5em);flex-direction:column;display:flex}:host([dividers]){gap:0}:host([hidden]){display:none}[part=group]{gap:var(--_menu-item-gap);flex-direction:column;display:flex}:host([dividers]) [part=group]{padding-block:var(--_menu-group-gap);border-block-end:solid 1px var(--menu-divider-color,var(--shade-2))}[part=heading]{opacity:var(--menu-heading-opacity,.75);align-items:center;gap:.25em;padding:.25em .5em;display:flex}[part=item]{padding:var(--menu-item-padding,.5em);border-radius:var(--menu-radius,var(--radius));color:var(--menu-color,currentColor);font:inherit;text-align:start;cursor:pointer;-webkit-user-select:none;user-select:none;touch-action:manipulation;appearance:none;background:0 0;border:0;align-items:center;gap:.25em;margin:0;display:flex}[part=item]:hover{box-shadow:inset var(--menu-hover,color-mix(in srgb, currentColor 6%, transparent)) 0 0 0 1000px}[part=item]:active{box-shadow:inset var(--menu-press,color-mix(in srgb, currentColor 12%, transparent)) 0 0 0 1000px}[part=item]:focus-visible{box-shadow:inset 0 0 0 .1em var(--menu-outline-color,var(--primary));outline:2px solid #0000}[part=item][active]{color:var(--menu-color-active,var(--primary));font-weight:700}[part=item]:disabled{opacity:var(--menu-opacity-disabled,.5);pointer-events:none}:host([icon-position=end]) [part=item] [part=icon]{opacity:.75;order:1}[part=label]{flex:1}"), p = class extends e(a) {
	constructor(...e) {
		super(...e), this.styles = f, this.groups = [], this.iconPosition = "start", this.dividers = !1, this._replaced = !1;
	}
	_onReplaceChange(e) {
		let t = e.currentTarget.assignedNodes({ flatten: !0 });
		this._replaced = t.some((e) => e.nodeType !== Node.TEXT_NODE || e.textContent?.trim());
	}
	_select(e) {
		this.dispatchEvent(new CustomEvent("menu-select", {
			detail: { id: e.id },
			bubbles: !0,
			composed: !0
		}));
	}
	_intent(e) {
		e.disabled || this.dispatchEvent(new CustomEvent("menu-intent", {
			detail: { id: e.id },
			bubbles: !0,
			composed: !0
		}));
	}
	_renderItem(e) {
		let t = e.id === this.active;
		return o`
            <button
                type="button"
                part="item"
                ?active=${t}
                ?disabled=${e.disabled}
                aria-current=${d(t ? "page" : void 0)}
                @click=${() => this._select(e)}
                @pointerenter=${() => this._intent(e)}
                @focus=${() => this._intent(e)}
            >
                ${e.icon ? o`<ptc-ui-icon part="icon" name=${i(e.icon, t)}></ptc-ui-icon>` : s}
                <span part="label">${e.label}</span>
            </button>
        `;
	}
	render() {
		return o`
            <slot name="replace" @slotchange=${this._onReplaceChange}></slot>
            ${this._replaced ? s : this._renderGroups()}
        `;
	}
	_renderGroups() {
		return this.groups.map((e) => o`
                <div part="group" role="group" aria-label=${d(e.label)}>
                    ${e.label ? o`<div part="heading">
                              ${e.icon ? o`<ptc-ui-icon name=${e.icon}></ptc-ui-icon>` : s}
                              ${e.label}
                          </div>` : s}
                    ${e.items.map((e) => this._renderItem(e))}
                </div>
            `);
	}
};
n([l({ attribute: !1 }), t("design:type", Array)], p.prototype, "groups", void 0), n([l({ type: String }), t("design:type", String)], p.prototype, "active", void 0), n([l({
	type: String,
	reflect: !0,
	attribute: "icon-position"
}), t("design:type", String)], p.prototype, "iconPosition", void 0), n([l({
	type: Boolean,
	reflect: !0
}), t("design:type", Object)], p.prototype, "dividers", void 0), n([u(), t("design:type", Object)], p.prototype, "_replaced", void 0), p = n([c("ptc-ui-menu")], p);
//#endregion
export { p as t };

//# sourceMappingURL=menu-hhdLG07g.js.map